
import WidgetMixins from '../../../../mixins/WidgetMixins';
import DialogValidationMixin from '../../../../mixins/DialogValidationMixin';
import Component, { mixins } from 'vue-class-component';
import { loadWidget } from '@/utils/helpers';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import { IGroup, PayloadState } from '@/types/types';
const contactModule = namespace('contact');
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Field is required',
});

@Component({
  name: 'AddGroupDialog',
  components: {
    ValidationProvider,
    ValidationObserver,
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
})
export default class AddGroupDialog extends mixins(
  WidgetMixins,
  DialogValidationMixin
) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @contactModule.Getter('getResetFormValues') resetFormValues!: IGroup;

  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading
  @Prop({ default: false }) link!: string;

  group: Pick<IGroup, 'name' | 'description'> = {
    name: '',
    description: '',
  };

  @Watch('resetFormState')
  onFormChange(payload: boolean): void {
    if (payload) {
      this.group = { ...this.resetFormValues };
    } else this.$store.dispatch('resetFormValues', false, { root: true });
  }

  @Emit('group')
  addGroup(): Pick<IGroup, 'name' | 'description'> {
    return this.group;
  }

  @Emit('actions')
  close(): PayloadState {
    return {
      idx: 'add',
      state: false,
    };
  }
}
